import { Controller } from 'react-hook-form';
import { Textarea } from '@ui/src';
import { useEffect, useState } from 'react';
import { AnnualIncomesTypes } from './types';
import RegulatedCompanyRow from './row';
import AnnualIncome from './annual-income';
import { CustomerStatus } from '../../../../../hoc/common/types';

import cn from './styles.module.css';

const AnnualIncomes = ({
  annualIncomes,
  fields,
  setTotalIncomeError,
  clearErrors,
  setValue,
  totalIncomeError,
  errors,
  control,
  status,
}: AnnualIncomesTypes) => {
  const [totalPercent, setTotalPercent] = useState(0);

  const otherAnnualIncome = annualIncomes?.find((item) =>
    item.value?.includes('Other'),
  );

  useEffect(() => {
    if (fields && annualIncomes) {
      if (
        Array.isArray(fields?.sourcesOfAnnualIncomes) &&
        fields?.sourcesOfAnnualIncomes?.length
      ) {
        let percentValues = 0;

        fields?.sourcesOfAnnualIncomes?.forEach((item) => {
          percentValues += Number(item.percentage);
        });

        if (percentValues > 100) {
          setTotalIncomeError('Source of annual income in % more than 100%');
        } else {
          setTotalIncomeError('');
        }

        setTotalPercent(percentValues);
      }
    }
  }, [fields, annualIncomes]);

  useEffect(() => {
    if (
      annualIncomes &&
      fields?.sourcesOfAnnualIncomesOther &&
      Array.isArray(fields?.sourcesOfAnnualIncomes) &&
      !Number(
        fields?.sourcesOfAnnualIncomes?.find(
          (item) => item.sourceOfAnnualIncomeId === otherAnnualIncome?.id,
        )?.percentage,
      )
    ) {
      clearErrors(['sourcesOfAnnualIncomesOther']);
      setValue('sourcesOfAnnualIncomesOther', '');
    }
  }, [
    fields?.sourcesOfAnnualIncomesOther,
    fields?.sourcesOfAnnualIncomes,
    annualIncomes,
  ]);

  return (
    <div className={cn.annualIncomesWrapper}>
      <div className={cn.annualIncomesTitle}>
        Source of annual income in %:{' '}
        <span>Total must equal 100% (currently {totalPercent}%)</span>
      </div>
      {totalIncomeError && (
        <div className={cn.totalError}>{totalIncomeError}</div>
      )}
      {errors?.sourcesOfAnnualIncomes?.message && (
        <div className={cn.totalError}>
          {errors?.sourcesOfAnnualIncomes?.message}
        </div>
      )}
      <div className={cn.annualIncomeList}>
        {annualIncomes?.map((item) => (
          <AnnualIncome
            key={item.id}
            id={item.id}
            name={item.value}
            clearErrors={clearErrors}
            status={status}
            annualIncomesValues={
              fields?.sourcesOfAnnualIncomes as {
                sourceOfAnnualIncomeId: string;
                percentage?: string | number;
              }[]
            }
            setValue={setValue}
            annualIncomesValue={(
              fields?.sourcesOfAnnualIncomes as {
                sourceOfAnnualIncomeId: string;
                percentage?: string | number;
              }[]
            )?.find(
              (sourcesOfAnnualIncome) =>
                sourcesOfAnnualIncome.sourceOfAnnualIncomeId === item.id,
            )}
          />
        ))}
        {annualIncomes &&
          Array.isArray(fields?.sourcesOfAnnualIncomes) &&
          Number(
            fields?.sourcesOfAnnualIncomes?.find(
              (item) => item.sourceOfAnnualIncomeId === otherAnnualIncome?.id,
            )?.percentage,
          ) > 0 && (
            <RegulatedCompanyRow title="Other income" annualIncome textarea>
              <Controller
                control={control}
                name="sourcesOfAnnualIncomesOther"
                defaultValue=""
                render={({ field: { onChange, value, name } }) => (
                  <Textarea
                    name={name}
                    title=""
                    placeholder="Describe income..."
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      clearErrors(['sourcesOfAnnualIncomesOther']);
                    }}
                    className={`borderless ${cn.pepTextarea} ${cn.stepOneTextarea}`}
                    error={errors?.sourcesOfAnnualIncomesOther?.message}
                    disabled={status === CustomerStatus.CLOSED}
                    tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
                  />
                )}
              />
            </RegulatedCompanyRow>
          )}
      </div>
      <Controller
        control={control}
        name="sourcesOfAnnualIncomes"
        defaultValue={[]}
        render={({ field: { name } }) => <input type="hidden" name={name} />}
      />
    </div>
  );
};

export default AnnualIncomes;
